import hexagonImage from '@static/header/andres-urena-qSw5XKtUyus-unsplash.jpg';
import eventHeaderImage from '../../static/industries/event.png';
import socialMediaHeaderImage from '@static/header/social_media_page_header.jpg';
import educationHeaderImage from '@static/header/santi-vedri-o-5-e-mzfdxedg-unsplash.png';
import automobileHeaderImage from '@static/header/steven-binotto-bz-yzg-tu-dj-0-unsplash.png';
import enterpriseHeaderImage from '../../static/industries/enterprise.png';
import healthCareHeaderImage from '@static/header/ani-kolleshi-7-jjn-j-qa-9-f-y-unsplash.png';
import realEstateHeaderImage from '@static/header/sean-pollock-ph-yq-704-ffd-a-unsplash.png';
import saasHeaderImage from '../../static/industries/saas.png';
import travelHeaderImage from '@static/header/simon-english-48-ner-zqc-hgo-unsplash.png';
import virtualRealityHeaderImage from '@static/header/uriel-soberanes-mx-vk-w-pi-ja-ls-unsplash.png';
import mediaAndEntertainmentHeaderImage from '../../static/industries/media.png';
import onDemandHeaderImage from '../../static/industries/ondemand.png';
import finTechHeaderImage from '@static/header/clay-banks-xv-s-u-k-uo-uao-unsplash.png';
import {
  FeaturePackedSoftwareIcon,
  PhoneIcon,
  AudiencesIcon,
  ConferencesIcon,
  CorporateEventsIcon,
  GearIcon,
  SportsEntertainmentIcon,
  TradeShowsIcon,
  RealTimeResultsIcon,
  AutomatedSolutionsIcon,
  InfusingCollaborationIcon,
  SecureRootsIcon,
  OperationExcellenceIcon,
  MultiChannelApproachIcon,
  VideostreamingIcon,
  MusicstreamingIcon,
  PhotoeditingandsharingIcon,
  GamingIcon,
  ContentaggregationIcon,
  VideoBasedinteractiveIcon,
  SynergisticLearningIcon,
  SkillBoostingAppsIcon,
  SchoolManagementIcon,
  OnlineLearningAppsIcon,
  EngagingSolutionsIcon,
  EmployeeEngagementIcon,
  CorporateTrainingAppsIcon,
  UniqueSolutionsIcon,
  HolisticApproachIcon,
  AdvancedTechnologyIcon,
  AutomatedSolutionIcon,
  ManageandMonitorIcon,
  AdvancedAnalyticsIcon,
  ClientCentricApproachIcon,
  VirtualRealityExcellenceIcon,
  VirtualRealityIcon,
  InsightFullsolutionsIcon,
  AutomatedExperienceIcon,
  PersonalisedExperienceIcon,
  TravelPlanningIcon,
  RentalvehiclebookingIcon,
  CrmSolutionsIcon,
  SpecificFocusIcon,
  BusinessValueIcon,
  NeutralPovIcon,
  DataPrivacyIcon,
  CustomizableSocialMediaIcon,
  ReportAnalysiIcon,
  CustomSocialNetworkingIcon,
  SocialNetworkAnalysisToolsIcon,
  MessagingAppIcon,
  VideobaseAppIcon,
  MobiledatingappsIcon,
  HealthCareDataPrivacyIcon,
  WearableTechIcon,
  PersonalPatientCheckIcon,
  FinTechSecureRootsIcon,
  FreshScriptIcon,
  ReportAnalysisIcon,
  TargetingMillennialsIcon,
  PosPaymentsandSecurityIcon,
  CustomerRelevancyIcon,
  FabricoLogo,
  GradleLogo,
} from '@components/Svg';
import XMPPLogo from '@static/logo/xmpp-logo.png';
import SQLiteLogo from '@static/logo/sqlite-logo.png';
import AlamofireLogo from '@static/logo/Alamofire.png';
import RxJavaLogo from '@static/logo/RxJava.png';
const event = {
  title: 'Event',
  overview:
    "Whether you'd like to organize an event or maybe you'd like to sell the tickets of the events you've undertook, we cover everyone.  We as a team, understand what all problems you as an organizer or a ticket lender can face and we're forever ready to provide you solutions and a well-working platform, where handling events will turn out to be the least of your stresses.",
  headerImage: eventHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/event',
  betterThanOther: {
    items: [
      {
        icon: FeaturePackedSoftwareIcon,
        title: 'Feature-Packed Software',
        description:
          'We provide all the possible features you can think of Booking management? Managed. Integrating payments? Done. Securing customer information? Secured. Personalizing experience? Got it. These are just a few on many functionalities our experienced team can add up.',
      },
      {
        icon: PhoneIcon,
        title: 'Modern Technology Implemented',
        description:
          'Our team of event app designer and developers have the medium to make your app next-gen. We can integrate blockchain technology, can power your event app with technologies like BLE and NFC, beacon device implementation. You say it.',
      },
      {
        icon: AudiencesIcon,
        title: 'Covering Wider Audiences',
        description:
          'Our suite of event app services covers a huge audience as we provide end to end solutions for corporate events, conferences, trade shows, sports, entertainment, or a custom event of your choice.',
      },
    ],
  },
  features: {
    title: 'Features',
    items: [
      {
        list: [
          'Event creation',
          'The event search feature in apps',
          'In-app Payments',
          'In-app Analytics',
        ],
      },
      {
        list: [
          'Photo sharing',
          'Event apps with GPS feature',
          'Messaging',
          'Event calendar',
        ],
      },
      {
        list: [
          'Push notification',
          'Event app development with a chatbot feature',
          'Event app development with ticket booking feature',
        ],
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    items: [
      {
        list: [
          'Ticket Management System',
          'Event Web Applications',
          'eTicketing Solutions',
        ],
      },
      {
        list: [
          'Web & Mobile Booking',
          'Online Registration System',
          'CRM Application Development',
        ],
      },
      {
        list: [
          'POS Software',
          'Venue/ Coupon/ Category Management',
          'Real-time Reporting & Tracking',
        ],
      },
    ],
  },
  serviceCatalogues: {
    list1: [
      { icon: CorporateEventsIcon, title: 'Corporate Events' },
      { icon: ConferencesIcon, title: 'Conferences' },
      { icon: TradeShowsIcon, title: 'Trade shows' },
    ],
    list2: [
      { icon: SportsEntertainmentIcon, title: 'Sports and Entertainment' },
      { icon: GearIcon, title: 'Customizable event schedule platform' },
    ],
  },
};

const enterprise = {
  title: 'Enterprise',
  overview:
    'What makes your enterprise stand out in this competitive modern age? It may be correct that you are the best at the services and goods you provide. But ask yourself, is that enough? While a majority of manufacturers and service providers seek the best product, they also need to find the best way to engage their users. This is where we come in handy.',
  headerImage: enterpriseHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/enterprise',
  betterThanOther: {
    items: [
      {
        icon: AutomatedSolutionIcon,
        title: 'Automated Solutions',
        description:
          'Our automated solutions have the ability to increase data flows, lessen prices, and to make the portability safer than ever.',
      },
      {
        icon: ManageandMonitorIcon,
        title: 'Manage and Monitor',
        description:
          'Our all-round, accessible and customizable solutions make managing business hassle-free.',
      },
      {
        icon: AdvancedAnalyticsIcon,
        title: 'Advanced Analytics',
        description:
          'Our advanced analytics algorithms and techniques give you crisp and precise stats which help you increase business.',
      },
      {
        icon: PosPaymentsandSecurityIcon,
        title: 'POS Payments and Security',
        description:
          'We ensure using trustworthy payment options that are cost-effective for the clients.',
      },
      {
        icon: CustomerRelevancyIcon,
        title: 'Customer Relevancy',
        description:
          'With digitally matured customers, they understand the difference between what’s meaningful to them and what’s just an advertising trick. Our experienced team knows how to give exactly what’s relevant to the user without costing them your brand loyalty.',
      },
      {
        icon: TargetingMillennialsIcon,
        title: 'Targeting Millennials',
        description:
          'Whatever is pleasing for the eyes is going to sell in today’s market. Our team keeps things simple yet complex in its own ways to attract generation-Z.',
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    items: [
      {
        list: [
          'Marketing automation',
          'Enterprise smart search',
          'Digital asset management',
          'Document management',
        ],
      },
      {
        list: [
          'Currency converter',
          'Secure Payment Gateway',
          'Easy to use admin control panel',
          'Filtered search',
        ],
      },
      {
        list: [
          'Interactive scheduling',
          'Comprehensive reports',
          'API integration',
        ],
      },
    ],
  },
  features: {
    title: 'Features',
    items: [
      {
        list: [
          'Web & Mobile Booking Systems',
          'Cloud Mobility Solutions',
          'Integration with existing enterprise services & data',
          'Enterprise Mobility',
          'Cross-platform accommodation/support',
        ],
      },
      {
        list: [
          'm-Commerce, B2B & B2C',
          'Application Maintenance Services',
          'Product Stock Management & Tracking',
          'Web content management',
          'Workflow management',
        ],
      },
      {
        list: [
          'Marketing automation',
          'Enterprise smart search',
          'Digital asset management',
          'Document management',
        ],
      },
    ],
  },
};

const automobile = {
  title: 'Automobile',
  overview:
    'Need a complete package of services and solutions in the transport and automotive industry? Our team has special expertise in building software for the automotive sector. From product development to inventory management, ERP and CRM to API bridging applications, customer service support to enterprise mobility solutions, you say it, we provide it with all.',
  headerImage: automobileHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/automobile',
  betterThanOther: {
    items: [
      {
        icon: RealTimeResultsIcon,
        title: 'Real-time Results',
        description:
          'This industry is all about instant updates. And we understand the need of having 24*7 access to things because of how patience-less the Generation-Z has gotten. Our unique algorithms mixed with our decision-making matrix and communication framework make it very easy for stakeholders to get real-time access to the required information.',
      },
      {
        icon: AutomatedSolutionsIcon,
        title: 'Automated Solutions',
        description:
          'Our automated solutions have the ability to increase data flows, lessen prices, and to make the portability safer than ever. Our strict engineering disciplines allows us to implement precise techniques and practices to help us assure quality at all levels.',
      },
      {
        icon: InfusingCollaborationIcon,
        title: 'Result-driven Approach',
        description:
          'Our immensely experienced team makes us highly competent when it comes to understanding customer needs and, thus fulfilling them with class-leading solutions. We apply direct and result-driven approaches from the very first day.',
      },
    ],
  },
  challenges: {
    title: 'Challenges',
    content: [
      {
        title: 'Dependency',
        description:
          'This industry is the most hardware-driven, which makes it a little tricky to keep sight of the information. But with years of experience in this field, our team is competent and more ready than ever to face issues like these.',
      },
      {
        title: 'Regulation Compliance',
        description:
          'Regulations implied by the government can be tricky to handle. With the many restrictions implemented, we know how to create solutions, like warnings, alerts, reminders, scheduling recommendations, time limitations, etc., resolving all these restraints legally and within the limits.',
      },
      {
        title: 'Competitions',
        description:
          'Like literally every other aspect of our day to day lives, this industry is filled with competitions, which is increasing day by day. With our solutions, our clients are able to find the best demand-need keys, aggressive measures and arrange for sophisticated supplies to crack it to success.',
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    items: [
      {
        list: [
          'BI and Data Warehousing Solutions',
          'Dealer Management Systems (DMS)',
          'E-Commerce, CRM and ERP Solutions',
        ],
      },
      {
        list: [
          'Supply Chain Management (SCM)',
          'Management Information Systems (MIS)',
          'Product Life Cycle Management (PLCM)',
        ],
      },
      {
        list: [
          'Enterprise Mobility Solutions',
          'Software Maintenance and Support',
          'Logistics and Inventory Solutions',
        ],
      },
    ],
  },
};

const mediaAndEntertainment = {
  title: 'Media and Entertainment',
  overview:
    'We fuse mobility with the media. We have a team full of expertise in the field of media and entertainment, no matter how specific your needs are, we can bring you the most gratifying matches of solutions for your M&E project.',
  headerImage: mediaAndEntertainmentHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/media-and-entertainment',
  betterThanOther: {
    items: [
      {
        icon: SecureRootsIcon,
        title: 'Secure Roots',
        description:
          "We know how much privacy matters to our users. Our latest algorithms keep our users' data safe and secure thanks to our highly safe encryption methodologies and of course, our group of experts.",
      },
      {
        icon: OperationExcellenceIcon,
        title: 'Operation Excellence',
        description:
          'Our apps are smoother than butter (or whatever the smoothest thing there is). With decades of experience in the field of media and entertainment, our developers just know how to keep things smooth yet subtle, after all who wants buffering lags while watching those cute cat videos?',
      },
      {
        icon: MultiChannelApproachIcon,
        title: 'Multi-Channel Approach',
        description:
          "Our easy yet complex working model makes sure that our product is working seamlessly across all the platforms and yet all the functionality of the product stays up to the mark, whether it's online connectivity or background downloading.",
      },
    ],
  },
  features: {
    title: 'Features',
    items: [
      {
        list: [
          'In-app purchases',
          'Push notifications',
          'Social media integration',
        ],
      },
      {
        list: ['Localization', 'Live chats', 'Reminders'],
      },
      {
        list: [
          'Audio & video streaming',
          'Real-time content update',
          'Text and GPS based facilities',
        ],
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    list1: [
      'Campaign and marketing management',
      'Video and film management',
      'Audience and broadcasting management',
      'Workflow management',
      'Media content management',
      'Digital asset management',
      'Distribution management',
    ],
    list2: [
      'Workflow Management Solutions',
      'Salesforce Automation',
      'Full-Cycle ERP /CRM',
      'Product Development / Digital SCM',
      'Legacy Migration',
      'AR/VR integration',
      'AI integration',
      'Blockchain addition',
    ],
  },
  // services: {
  //   title: 'Other Services',
  //   list1: [
  //     'Workflow Management Solutions',
  //     'Salesforce Automation',
  //     'Full-Cycle ERP /CRM',
  //     'Product Development / Digital SCM',
  //   ],
  //   list2: [
  //     'Legacy Migration',
  //     'AR/VR integration',
  //     'AI integration',
  //     'Blockchain addition',
  //   ],
  // },
  serviceCatalogues: {
    list1: [
      { icon: VideostreamingIcon, title: 'Video streaming apps' },
      { icon: MusicstreamingIcon, title: 'Music streaming apps' },
      {
        icon: PhotoeditingandsharingIcon,
        title: 'Photo editing and sharing apps',
      },
    ],
    list2: [
      { icon: GamingIcon, title: 'Gaming apps' },
      { icon: ContentaggregationIcon, title: 'Content aggregation apps' },
    ],
  },
};

const education = {
  title: 'Education',
  overview:
    "The learning in this new age should be flexible, and that's where we aim for. Whether it's the place, time, teacher, mood, course, etc., one does not have to sit around and study with someone who has been allotted to them, at the allotted time, at some allotted place.\nOur team of experts understands this problem and has all the unique solutions which you might require in your app. From one-to-one student-device interaction to advance the timetable allocation system for your high school, we got it all covered.",
  headerImage: educationHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/education',
  betterThanOther: {
    items: [
      {
        icon: VideoBasedinteractiveIcon,
        title: 'Video-based/Interactive Learning',
        description:
          "There's nothing better for the students where they get to learn at their own pace. Or when they get to test themselves interactively instead of those old bogus methods where they have to fill tons of pages. Our experts know just how to provide a learning value to users.",
      },
      {
        icon: SynergisticLearningIcon,
        title: 'Collaborative Learning',
        description:
          'Nothing beats solo studying, but for times when group study is required - our unique features like OCR image sharing, easy testing and grading systems, analytics of performance and comparative tools, etc. cover this up for you.',
      },
      {
        icon: EngagingSolutionsIcon,
        title: 'Engaging Solutions',
        description:
          'We know how to create aesthetically pleasing interactive apps and it is a big thing in e-learning apps as it kills boredom and keeps students engaged.',
      },
    ],
  },
  serviceCatalogues: {
    title: 'Our most in-demand services',
    items: [
      {
        icon: OnlineLearningAppsIcon,
        title: 'Online Learning Apps',
        description:
          'App where students can log in, study whenever and whatever they want. Includes various ways of learning, from video-based to interactive game-based.',
      },
      {
        icon: SchoolManagementIcon,
        title: 'School Management',
        description:
          'We create apps which can handle every aspect and activity which you can think of. Need to handle employee payment? Got it. Do teachers need to pass on the homework to the students? Check. Do parents need to be reported about the mischief their pupil has been causing? Covered.',
      },
      {
        icon: CorporateTrainingAppsIcon,
        title: 'Corporate Training Apps',
        description:
          "College freshers aren't as ready for the corporate world, our corporate training apps follow an easy design which creates training modules.",
      },
      {
        icon: SkillBoostingAppsIcon,
        title: 'Skill Boosting Apps',
        description:
          'Want to teach that new skill which keeps your employees stress free? Or that new tech which is going to trend soon? From our skill-boosting apps you can train your employees so that they remain ready for the future.',
      },
      {
        icon: EmployeeEngagementIcon,
        title: 'Employee Engagement',
        description: 'Great module for all the employees to stay connected.',
      },
    ],
    footerText:
      'Missing something? Just say it and we are sure that you end up impressed.',
  },
  solutions: {
    title: 'Other Solutions',
    items: [
      {
        list: [
          'E-learning (Self-paced, Instructor-led)',
          'Web Applications',
          'Payment Systems Integration',
        ],
      },
      {
        list: [
          'Mobile Learning Applications',
          'Learning Management System (LMS)',
          'Content Management System (CMS)',
        ],
      },
      {
        list: [
          'Education Enterprise Solutions',
          'Edu Games Development',
          'Digital Library & Video Integration',
        ],
      },
    ],
  },
  benefits: {
    title: 'Benefits of our solutions',
    items: [
      {
        list: [
          'Real-time interaction',
          'Easy analytics',
          'Greater adaptation to training needs',
          'Better engagements and interacts',
        ],
      },
      {
        list: [
          'Flexibility of usage',
          'More push notification reaches',
          'The higher course accomplishment rate',
          'Surged cost-effectiveness',
        ],
      },
    ],
  },
};

const realEstate = {
  title: 'Real Estate',
  overview:
    "Similar to other fields, the real estate industry has moved its functioning processes from old-school offline operations in this modern age of fast internet. To reach millions of possible clients looking for their dream home or, maybe an ideal business space.\nOur experts know how there is a change in consumer behaviour when it comes to property and we're ready with the dealing procedure required for commercial real estate challenges across the globe. Our unique solutions give constructors, dealers, contractors and aggregators a platform where they can serve the end-users without the need of attending to them.",
  headerImage: realEstateHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/real-estate',
  betterThanOther: {
    items: [
      {
        icon: UniqueSolutionsIcon,
        title: 'Unique Solutions',
        description:
          'With our easy to use interface, service providers find it very easy and can provide all the required information pleasingly to millennials seeking a satisfying online service.',
      },
      {
        icon: HolisticApproachIcon,
        title: 'Holistic Approach',
        description:
          'Our holistic approach helps you to have a local platform that delivers great business results. Our web and mobile development solutions make it easy for you to manage your listed property for your clients in an aesthetically pleasing way.',
      },
      {
        icon: AdvancedTechnologyIcon,
        title: 'Advanced Technology',
        description:
          'With the introduction of new concepts like AR/VR, IoT, Blockchain and AI technology, it gets easier for your users to look at the property in an interactive way where they can completely examine it without being physically present. Not just this, there are various other solutions which makes it a lot easier for you and your clients.',
      },
    ],
  },
  promises: {
    title: 'Our Promises',
    content: [
      {
        title: 'Qualified Leads',
        description:
          'Our targeted development approach brings you closer to warm leads.',
      },
      {
        title: 'Universal Customer Access',
        description:
          'As it suggests, we help you connect internationally, helping you enrich your number of possibilities, experience and portfolio.',
      },
      {
        title: 'Nurture Massive Inventory',
        description:
          'Our group of experts shines when it comes to creating new portals which allow maintaining properties from multiple dealers and brokers.',
      },
    ],
  },
  stakeholders: {
    title: 'Stakeholders',
    description:
      "We develop apps for all three levels of stakeholders, whether it's the buyers, sellers or the middlemen.",
    content: [
      {
        title: 'Buyers',
        description:
          "With the ability to use location maps, AR/VR technology to take a property tour, etc. It's an interactive way for buyers to experience the property without being physically available.",
      },
      {
        title: 'Sellers',
        description:
          "We offer a different set of features in our mobile solution for real estate companies renting or selling their properties. We can provide them with a platform to facilitate viewing of the license, buyers' backgrounds, and their credit scores.",
      },
      {
        title: 'Aggregators',
        description:
          'We offer various services for real estate middlemen, like - property image/video presentation, listing submission and payment processing.',
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    items: [
      {
        list: [
          'ERP/CRM Solutions',
          'IDX Update & Management',
          'Content Management System',
          'Existing Website Redevelopment',
        ],
      },
      {
        list: [
          'Auction/Property Web Development',
          'Property Listing Selection',
          'Mobile Optimized/Fully responsive apps',
          'Real Estate Mobile App Development',
        ],
      },
      {
        list: [
          'Custom Page Development',
          'Enterprise Solutions',
          'Lead Management Solutions',
        ],
      },
    ],
  },
};

const onDemand = {
  title: 'On Demand',
  overview:
    "We'd like to put a really nice intro to it, but with the endless possibilities available, we failed.  (Probably the only thing we failed at). Simply put, our team takes your business idea, mix it with our expertise view, experience and real-life clarifications and offer you that one ultimate app, that one solution, which will revolutionise your brand and make it a household name.",
  headerImage: onDemandHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/on-demand',
  betterThanOther: {
    items: [
      {
        icon: AutomatedSolutionIcon,
        title: 'Automated Solutions',
        description:
          'Our automated solutions have the ability to increase data flows, lessen prices, and to make the portability safer than ever.',
      },
      {
        icon: ManageandMonitorIcon,
        title: 'Manage and Monitor',
        description:
          'Our all-round, accessible and customizable solutions make managing business hassle free.',
      },
      {
        icon: AdvancedAnalyticsIcon,
        title: 'Advanced Analytics',
        description:
          'Our advanced analytics algorithms and techniques give you crisp and precise stats which help you increase business.',
      },
    ],
  },
  implementedTechnology: {
    title: 'Implemented Technology',
    description:
      "On Demand services is a big package compressed in such a small word. There are various categories of services which can be included in it, Thus, many different technologies are required. Luckily for you, our highly qualified team doesn't crack under this kind of pressure. We got it.",
    iconsPng: [XMPPLogo, SQLiteLogo, AlamofireLogo, RxJavaLogo],
    iconsSvg: [FabricoLogo, GradleLogo],
  },
  typesOfApps: {
    title: 'Types of apps provided',
    items: [
      {
        list: ['Taxi', 'Food', 'Laundry', 'Grocery'],
      },
      {
        list: ['Fitness', 'Home Services', 'Courier', 'Pet Services'],
      },
      {
        list: [
          'Repair & maintenance',
          'House Cleaning',
          'Doctor on demand',
          'Beauty Salon',
        ],
      },
      {
        list: ['Coaching', 'Parking', 'Logistics'],
      },
    ],
  },
  onDemandServices: {
    title: 'Perks of On Demand Services',
    items: [
      {
        title: 'One-Touch profile integration',
        list: [
          'Social media integration',
          'Ensuring high engagement levels',
          'Customized product offerings',
          'Gateway to building on-demand brand loyalty',
        ],
      },
      {
        title: 'Services at your fingertips',
        list: [
          'Browsing service categories',
          'Access to products and services on finger tips',
          'Easy service filtration',
          'Effortless product/service comparisons',
        ],
      },
      {
        title: 'Simplified ordering',
        list: [
          'Order viewing',
          'Order placement with details',
          'Order reviewing prior to placement',
          'Access to order history and records',
          'Scheduling the order',
        ],
      },
      {
        title: 'All-inclusive order tracking',
        list: [
          'Order status information',
          'Real time order tracking',
          'Tracking multiple service requests',
          'Route monitoring',
          'Automatic status updates',
        ],
      },
    ],
  },
};

const virtualReality = {
  title: 'Virtual Reality',
  overview:
    "Ok, help us imagine this scenario- you had this family outing planned, everyone was really excited for this Sunday where you were visiting this amusement park with your family, and everything was planned- food: ✓, first aid: ✓, mat: ✓, sunglasses: ✓. You were ready. But when you wake up on  Sunday morning, you see it's raining like hell, and your kids are as disappointed as you are. You wish that you could stop this rain somehow and get that sunny weather you were hoping for. Well, maybe that would be too much to ask for, but a VR headset with a roller coaster simulation might help. At this point, that's your best alternative, and believe us, it's a lot better than it used to be.",
  headerImage: virtualRealityHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/virtual-reality',
  betterThanOther: {
    items: [
      {
        icon: ClientCentricApproachIcon,
        title: 'Client-Centric Approach',
        description:
          'Conceptualizing your ideas and turning them into a working model is what our team excels at. Your vision is our aim. Whatever you imagine, we build.',
      },
      {
        icon: VirtualRealityExcellenceIcon,
        title: 'Operation Excellence',
        description:
          " Our apps are smoother than Michael Jackson's moonwalk. With years of experience in the field of virtual reality, our developers just know how to keep things smooth yet subtle, after all, no one wants a lag while playing highly competitive games like Mario Kart, right?",
      },
      {
        icon: VirtualRealityIcon,
        title: 'Advanced Technology',
        description:
          'With the introduction of new concepts like IoT, Blockchain and AI technology along with our in-depth understanding, we bring the capability of crafting excellent user experiences and high-quality, well-tested products which run hand-in-hand with modern technology.',
      },
    ],
  },
  servicesAndSolutions: {
    title: 'Services and Solutions',
    items: [
      {
        list: [
          'Virtual 360 Tours',
          'Virtual Reality Training',
          'Virtual 3D Showroom',
          'VR Games',
          '3D Modeling Services',
          'VR Walkthrough',
        ],
      },
      {
        list: [
          'Virtual Events Solution',
          'Virtual Shopping Experience',
          'Virtual Reality App Development',
          'VR Game Development',
          'VR Content Development',
        ],
      },
      {
        list: [
          'Visual Storyboard Development',
          'Virtual Kioks and Product Displays',
          '3D Graphics & Animations',
          'VR Integration And Deployment',
          'VR Maintenance And Support',
        ],
      },
    ],
  },
  servicesWorkOn: {
    title: 'Services we work on',
    items: [
      {
        list: ['SteamVR', 'Unity', 'Daydream'],
      },
      {
        list: ['Oculus', 'Gear 360', 'WebVR'],
      },
      {
        list: ['Cardboard', 'GearVR', 'HTC Vive'],
      },
    ],
  },
  vrHelp: {
    title: 'How VR can help',
    content: [
      {
        title: 'Gaming',
        description:
          'Whenever someone thinks about VR, the first thing that comes to mind is gaming. VR is one of the most advanced technologies in the world right now and is advancing day by day. Our team has that skill which makes VR gaming mesmerizing and addictive.',
      },
      {
        title: 'Education',
        description:
          'We have engaging solutions when it comes to education via VR. We know how to create aesthetically pleasing interactive apps, and it is a big thing in e-learning apps as it kills boredom and keeps the students engaged.',
      },
      {
        title: '360 Tour',
        description:
          'With VR in hand, it gets easier for customers to look at the property in an interactive way where they can completely examine it without being physically present. 360 virtual tours are taking its real estate and tourism businesses prospects to new heights.',
      },
      {
        title: 'Training',
        description:
          'From training IT technicians to doctors (yes, doctors!) VR plays a huge round in this field. It enables interactive and realistic virtual training for students and professionals across diverse industries.',
      },
    ],
  },
};

const travel = {
  title: 'Travel',
  overview:
    "We make you client's travel experience, seamless. Anywhere from hotel room selection to booking online tickets; from planning a jet-ski ride on a sunny day to reserving a seat in that most visited pizzeria, we got you covered. Our methods are convenient, our processes are hassle-free and our customers are satisfied, easy. Our motto is simple, Booking process should be as stressfree as the vacation itself.",
  headerImage: travelHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/travel',
  betterThanOther: {
    items: [
      {
        icon: InsightFullsolutionsIcon,
        title: 'Insightful Solution',
        description:
          'Our high-end comparative tools provide our customers with a large number of convenient data to choose from so that they are never out of options.',
      },
      {
        icon: AutomatedExperienceIcon,
        title: 'Automated Experience',
        description:
          'We make everything automated. CRM management? Automated. Personalised Suggestions? Automated. Navigation, payment system, check-ins and booking? Automated. We make sure the enduser has to expend the bare minimum effort to get their travel needs taken care of',
      },
      {
        icon: PersonalisedExperienceIcon,
        title: 'Personalised Experience',
        description:
          'Our highly qualified business analysis, project management, design and development teams work towards enhancing the search and booking options via personalized offers and intuitive user experience. And guess what? We personalise the entire journey and not just the booking part or the reserving part.',
      },
    ],
  },
  betterServices: {
    title: 'Services',
    items: [
      {
        icon: TravelPlanningIcon,
        title: 'Travel Planning',
        description:
          "We offer travel planning services where every bit of it is customisable or the entire bundle where everythings prefixed and anywhere in between. And it just doesn't include the tickets, it has everything from room reservations to location-based dine-in options.",
      },
      {
        icon: RentalvehiclebookingIcon,
        title: 'On-demand/Rental vehicle booking',
        description:
          'Whether your customers drive their way onto those lavish beaches or prefer booking a cab for those jungle safaris, you would be able to provide the service easily because our experienced team got your back.',
      },
      {
        icon: CrmSolutionsIcon,
        title: 'CRM Solutions',
        description:
          "Managing customer data is now easier than ever. Our specially developed methodologies make our client's job very easy.",
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    items: [
      {
        list: [
          'Web & Mobile Booking Systems',
          'Inventory & Procurement Management',
          'Payment Systems Integration',
        ],
      },
      {
        list: [
          'Travel Process re-engineering',
          'Navigation Systems',
          'Transaction Processing Systems',
        ],
      },
      {
        list: [
          'Pre & Post-trip Management Applications',
          'Customer Relationship Management',
          'Legacy Modernizations',
        ],
      },
    ],
  },
  functions: {
    title: 'Functions',
    items: [
      {
        list: [
          'Currency converter',
          'Complete travel guide',
          'Secure payment gateway integration',
          'GPS based location services',
        ],
      },
      {
        list: [
          'Easy to use admin control panel',
          'Filtered search',
          'Travel guides',
          'Reviews and recommendations',
        ],
      },
      {
        list: [
          'Hot deals',
          'Interactive scheduling',
          'Push notification',
          'API integration',
        ],
      },
      {
        list: [
          'Social media integration',
          'Comprehensive reports',
          'Well-devised search engine',
          'Virtual tour guide',
        ],
      },
    ],
  },
};

const saas = {
  title: 'SaaS',
  overview:
    'Software-as-a-service (Saas) is definitely the need of the hour with public demand for SaaS for different services increasing because of the obvious reasons. A good SaaS application requires a subtly layered implementation of security, tenancy, constructibility and dispensing nature. At CodeMyMobile, we have a team who has been handling SaaS projects for years and our clients are more than satisfied.',
  headerImage: saasHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/saas',
  betterThanOther: {
    title: 'How do we deliver better?',
    items: [
      {
        icon: SpecificFocusIcon,
        title: 'Specific Focus',
        description:
          'SaaS product development requires extreme knowledge and experience of working on programming languages and frameworks like Java, PHP, C#/.NET, NodeJS, Python. Luckily, our team has experts for this specifically.',
      },
      {
        icon: BusinessValueIcon,
        title: 'Business Value',
        description:
          'Our main focus alongside application development is to keep your business values upright by providing components like fast and easy deployment, meaningful Service Level Agreements (SLA) etc. Because the last thing we want as a team is to see our clients getting problems with this issue.',
      },
      {
        icon: NeutralPovIcon,
        title: 'Neutral POV',
        description:
          "Often times developers and clients keep looking at things from their point of view, which isn't always a win-win solution. Our team understands the value of neutral point of view and we keep our approach holistic at every decision we undertake and execute.",
      },
    ],
  },
  coreServices: {
    title: 'Core services',
    content: [
      {
        title: 'Development',
        description:
          'We help organizations plan and develop the exact solutions they want with the help of the best possible methodologies, thanks to our highly experienced team.',
      },
      {
        title: 'Optimization',
        description:
          'Our team knows how to get the best out of your current service pattern - with our experts working with you throughout your service offering, to come out with the best results.',
      },
      {
        title: 'Multi-Tenant Architecture',
        description:
          'When a single instance of the software runs on a server and serves multiple tenants. Since multiple single instances of software run on a single physical server, multi-tenancy requires continuous upgrades and enhancements.',
      },
      {
        title: 'Technology Migration',
        description:
          'We can migrate your existing SaaS application to whichever other tech stack you want to migrate to. This is what makes us stand out in the market.',
      },
      {
        title: 'Third-Party Integration',
        description:
          'From integrating payment gateways, to connecting external data sources, we can help you connect with third parties to make your functioning easy.',
      },
    ],
  },
  toolset: {
    title: 'Our Toolset',
    items: [
      {
        title: 'Frontend',
        list: [
          'Angular',
          'React',
          'Bootstrap',
          'Yii',
          'HTML',
          'Phalcon',
          'CSS',
        ],
      },
      {
        title: 'Backend',
        list: [
          'Node.js',
          'Grails',
          'Hibernate',
          'Express.js',
          'Spring',
          'Django',
          'Yii',
          'Phalcon',
        ],
      },
      {
        title: 'Database',
        list: ['MongoDB', 'MySQL', 'PostgreSQL'],
      },
      {
        title: 'Content Management',
        list: ['Wordpress', 'Gatsby'],
      },
      {
        title: 'Cloud consulting',
        list: [
          'AWS',
          'Docker',
          'Jenkins',
          'Microsoft Azure',
          'Google Cloud Platform',
        ],
      },
      {
        title: 'Big data',
        list: ['Hadoop', 'Cassandra', 'Spark', 'Python', 'R', 'Data Lakes '],
      },
    ],
  },
  capabilities: {
    title: 'Our capabilities in SaaS',
    items: [
      {
        list: ['Social Media', 'M-commerce', 'Enterprise', 'Entertainment'],
      },
      {
        list: [
          'Education',
          'Digital Content',
          'On-demand Solution',
          'IoT Management',
        ],
      },
      {
        list: ['Food Tech', 'Healthcare', 'Outdoor Activities', 'Banking'],
      },
    ],
  },
};

const socialMedia = {
  title: 'Social Media',
  overview:
    "We have a team full of expertise in the field of social media development, who can deliver for you an interactive social media application which can help your business grow exponentially. We don't only assure enhanced user fulfilment, but our team also provides top-notch technology with on-trend methodologies.",
  headerImage: socialMediaHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/social-media',
  betterThanOther: {
    items: [
      {
        icon: DataPrivacyIcon,
        title: 'Data Privacy',
        description:
          "We make sure that the user's data remains as per their wish. Our team executes the latest security procedures to ensure data privacy as well as maintaining application security.",
      },
      {
        icon: CustomizableSocialMediaIcon,
        title: 'Customizable Social Media',
        description:
          'Our team with decades of experience is fully capable to understand your needs in-and-out and curate the product just as our clients want it.',
      },
      {
        icon: ReportAnalysiIcon,
        title: 'Report Analysis',
        description:
          'We are living in the age of numbers and our team understands that  perfectly. Our highly data-efficient algorithms provide you the information in aesthetically pleasing and easily understandable numbers, tables, charts and graphs.',
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'UI/UX Design',
          'Web Application Development',
          'Mobile Application Development',
          'Enterprise Software Development',
        ],
      },
      {
        list: [
          'Product Strategy for Startups',
          'Quality Assurance',
          'Staff Augmentation & Dedicated Developers',
          'Maintenance & Support',
        ],
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    items: [
      {
        title: 'Business tools',
        list: [
          'Knowledge Base',
          'Calendar Management',
          'Task Management',
          'Polls',
          'Search',
        ],
      },
      {
        title: 'Employee networking',
        list: [
          'Real-time Messaging',
          'Discussions',
          'Notifications',
          'Intelligent Feed',
        ],
      },
      {
        title: 'Work process management',
        list: [
          'Version Control',
          'Document Collaboration',
          'Tagging',
          'File Sharing',
        ],
      },
      {
        title: 'Team evaluation',
        list: ['Voting', 'Ratings', 'Badges', 'Privileges'],
      },
      {
        title: 'Video collaboration',
        list: [
          'Video Calls',
          'Video Conferencing',
          'Enterprise Webcasting',
          'Video Messages',
        ],
      },
    ],
  },
  features: {
    title: 'Features you cannot say no to!',
    description:
      'We move hand in hand with the trending norms and latest functionalities out there, these are few of the many features we can provide our users:',
    items: [
      {
        list: [
          'Profile creation',
          'Map integration',
          'Media upload and sharing',
          'Push notification',
        ],
      },
      {
        list: [
          'Real-time chat',
          'Image and social edition',
          'The social media API integration',
        ],
      },
    ],
  },
  types: {
    title: 'Types of social media',
    items: [
      {
        icon: CustomSocialNetworkingIcon,
        title: 'Custom Social Networking',
        description:
          "Have something in your mind, but just don't know how to let it out? Don't worry we got you. Our experts are here to translate each and every detail from your brain to the app of your dreams.",
      },
      {
        icon: SocialNetworkAnalysisToolsIcon,
        title: 'Social Network Analysis Tools',
        description:
          'Curious about how well your business is performing? Our unique algorithms keep track of your analytics requirements and present you with the easiest and the most understandable way possible',
      },
      {
        icon: MessagingAppIcon,
        title: 'Messaging App',
        description:
          "Messaging is a big thing in today's age. We take care of that.  We develop platforms that enable instant connectivity in a secure environment.",
      },
      {
        icon: VideobaseAppIcon,
        title: 'Video based Apps',
        description:
          'Whether you want a YouTube-like app or a TikTok-like, or wait, are we missing something? You need not sweat, our team is here to understand your ideas and can build you with the best app of your interest.',
      },
      {
        icon: MobiledatingappsIcon,
        title: 'Mobile dating apps',
        description:
          'Powered by the geolocation ability and a robust verification algorithm, we simplify dating.',
      },
    ],
  },
};

const healthCare = {
  title: 'Health Care',
  overview:
    'Our team specializes in the field of healthcare app development. We provide top solutions to the most elite health brands around the globe. For them to stay ahead in attaining the health data-oriented services, our team is here with the best and most dependable digital solutions. And with the rise in fitness fanatics, tracking each step and each pulse of their heart beat, we know exactly what they are looking for.',
  headerImage: healthCareHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/health-care',
  betterThanOther: {
    items: [
      {
        icon: HealthCareDataPrivacyIcon,
        title: 'Data Privacy',
        description:
          "We make sure that the client's data remains as per their wish, whether they want to keep it to themselves or want to share it with their therapist. Data privacy is our first and foremost priority.",
      },
      {
        icon: WearableTechIcon,
        title: 'Wearable Tech',
        description:
          'In this age where almost everyone tracks their fitness either from their device or a fitness tracker, our team of experts provides personalized experience across all devices. We aim to use state-of-the-art technologies in our procedures.',
      },
      {
        icon: PersonalPatientCheckIcon,
        title: 'Patient Engagement',
        description:
          'Patients feel at ease with healthcare apps as they get the best consult from the best doctor and that too anytime from home. 40% of physicians have entrusted that mHealth has improved patient engagement rates.',
      },
    ],
  },
  solutions: {
    items: [
      {
        list: [
          'Mobile Hospital Management Solutions',
          'Fitness Tracking Apps',
          'Wearable App Development',
        ],
      },
      {
        list: [
          'Web and Mobile Healthcare Solutions',
          'Pharma IT Software Solutions',
          'Electronic Medical Records (EMR) Software',
        ],
      },
      {
        list: [
          'Electronic Health Records (EHR) Software',
          'Health Insurance Apps',
          'Clinical Management System Software',
        ],
      },
    ],
  },
  services: {
    title: 'Services',
    items: [
      {
        list: [
          'Electronic Health Record',
          'mPriscription',
          'Process Management',
          'Medical Insurance Claim',
        ],
      },
      {
        list: [
          'E-health Information Exchange',
          'Lab Management',
          'Patient Gateway',
          'Lifestyle Tracking',
        ],
      },
    ],
  },
  compliances: {
    title: '4-crucial-Cs\nWe provide in our mHealth App Development',
    description:
      'The 4Cs, aka fundamentals of a mHealth app, which provides a dynamic environment for clinicians, health care providers and patients.',
    content: [
      {
        title: 'Compliant',
        description:
          'Our apps obey various national and international regulations surrounding mHealth applications.',
      },
      {
        title: 'Comprehensive',
        description:
          'Our apps can be highly functioning, but everything funnels down to one thing: our users and their experience.',
      },
      {
        title: 'Connected',
        description:
          'Patients, according to their will, are always securely connected to their doctors and healthcare providers.',
      },
      {
        title: 'Confidential',
        description:
          'A patient information should be approachable to his doctor, not every doctor who wants to.',
      },
    ],
    footerText:
      'Compliances we follow to maintain privacy and security standards',
  },
  features: {
    title: 'Features you cannot say no to!',
    description:
      'We move hand in hand with the trending norms and latest functionalities out there, these are few of the many features we can provide our users:',
    items: [
      {
        list: [
          'Profile creation',
          'Map integration',
          'Media upload and sharing',
          'Push notification',
        ],
      },
      {
        list: [
          'Real-time chat',
          'Image and social edition',
          'The social media API integration',
        ],
      },
    ],
  },
  footerContent: [
    {
      title: 'HIPAA',
      description:
        'The Health Insurance Portability and Accountability Act (HIPAA) sets the standard for sensitive patient data protection, which encompasses nearly every aspect of U.S. healthcare. It operates on behalf of the HHS, or United States Department of Health & Human Services. It protects human healthcare rights in many sectors, including privacy.',
    },
    {
      title: 'FDA',
      description:
        'We follow strict guidelines provided by The Food and Drug Administration (FDA). The FDA is known for its work in regulating the development of new drugs, cosmetics, animal food, dietary supplements, medical devices, biological goods, and blood products.',
    },
  ],
};

const finTech = {
  title: 'FinTech',
  overview:
    'Making transactions faster is one thing and making them safe is another. Good news is, we excel at both. And not just this, the field of FinTech is our speciality. With so much to be done in finance management, our team provides you services from online banking to Bitcoin payment gateways and wallets, mutual funds marketplace to money transfer/e-wallet app development.',
  headerImage: finTechHeaderImage,
  image: hexagonImage,
  pageLink: '/industries/fintech',
  betterThanOther: {
    items: [
      {
        icon: FinTechSecureRootsIcon,
        title: 'Secure Roots',
        description:
          "We know how much security matters to our users. Our latest security patches keep our users' data safe and secure thanks to our highly safe encryption methodologies and of course, to our group of experts.",
      },
      {
        icon: FreshScriptIcon,
        title: 'Secure Roots',
        description:
          'Security is the most important aspect of a FinTech app, and we specialise in it. It’s important that the users feel safe and comfortable using your app, given the sensitive information they provide.',
      },
      {
        icon: ReportAnalysiIcon,
        title: 'Report Analysis',
        description:
          ' We are living in the age of numbers and our team understands that perfectly. Our highly data-efficient algorithms provide you with the information in aesthetically pleasing and easily understandable numbers, tables, charts and graphs.',
      },
    ],
  },
  loanAndMutualFundApps: {
    title: 'Our FinTech Specialities',
    description:
      '',
    subTitle: 'Loans & Mutual Funds App',
    subDescription:
      'It lets the end-users manage, categorize and control different loans, mutual fund, and other financial products or services from multiple banks and financial institutes into a single view.',
    items: [
      {
        title: 'Comprehensiveness',
        list: [
          'Flawless mobile application for loans and mutual funds',
          'PIN and password security',
          'Performance-driven mechanism',
          'Secure processes',
        ],
      },
      {
        title: 'Easiness',
        list: [
          'Advanced yet easy analytics',
          'Affordable post-purchase support and consulting',
          'Effective documentation and data storage',
          'Time and cost-savvy business tradings',
        ],
      },
      {
        title: 'Basic Features',
        list: [
          'Linking Bank Accounts',
          'Checking Eligibility',
          'Instalment Reminders',
          'Digital Application Forms',
          'Transaction Status',
          'Loan Status',
          'Live chat and support',
        ],
      },
    ],
  },
  onlineBankingApps: {
    subTitle: 'Online Banking App',
    subDescription:
      'Our online banking apps offer a complete turnkey online banking solution to the customers as they can perform any fund, stock or financial activities on their fingertips making it possible for the banker to provide everything under one roof.',
    items: [
      {
        title: 'Comprehensiveness',
        list: [
          'Banking Wallet',
          'POS Solution',
          'Bill reminders',
          'Crypto Wallet',
          'Payment gateway integration',
          'Authentication Management',
        ],
      },
      {
        title: 'Easiness',
        list: [
          'Global Access',
          'Easy Customer Relationship Management',
          'Smooth internal banking operations',
          'Marketing the banking service becomes easy',
          'Highlights Business USPs',
        ],
      },
      {
        title: 'Basic Features',
        list: [
          'Registration',
          'Online Transactions',
          'Multiple Payment Methods',
          'Payment Tracker',
          'Currency Conversion',
        ],
      },
    ],
  },
  eWalletApps: {
    subTitle: 'E-Wallet App',
    subDescription:
      'CodeMyMobile is at the forefront to help you to convert your eWallet solutions into a profitable business. We provide on-demand enterprise-grade customized eWallet app development solution for Android, iOS, and cross-platform devices.',
    items: [
      {
        title: 'Comprehensiveness',
        list: [
          'Fully flexible and secure payment app',
          'Expenditure and financial behaviour Monitored',
          'Cost-effective',
        ],
      },
      {
        title: 'Easiness',
        list: [
          'The smooth fund transfer process',
          'Less human capital engagement',
          'Lead generations',
          'Easy business expansion',
          'The far-reaching scope of a pretty extensive target market',
        ],
      },
      {
        title: 'Basic Features',
        list: [
          'Login/Registration',
          'Multiple Payment Options',
          'OTP',
          'Promo Code',
          'Online Passbook',
          'Transfer Status',
          'Group Wallet',
          'Multiple Currency Support',
        ],
      },
    ],
  },
  bitcoinCryptocurrencyApps: {
    subTitle: 'Bitcoin & Cryptocurrency App',
    subDescription:
      'A cryptocurrency app Development that meets all the user requirements steals the show. In the forefront of virtual currency with decentralization, no Government control or regulations, no impact of economy inflation, no banks or intermediaries, highly protected and the swift transaction to send, receive, store and invest, is what the customers can deal and trade on.',
    items: [
      {
        title: 'Comprehensiveness',
        list: [
          'Secure Trustworthy Data',
          'Public-Private Hybrid Blockchain',
          'Maintained Secrecy',
        ],
      },
      {
        title: 'Easiness',
        list: [
          "Blockchain's transparency and immutability simplifies and streamlines processes.",
          'Smart contracts automate processes, reducing the need for manual intervention.',
          'Tamper-proof records of transactions increase security and reduce the risk of fraud.',
        ],
      },
      {
        title: 'Basic Features',
        list: [
          'Instant Transfer',
          'Wallet',
          'Conversion',
          'Buy Cryptocurrency',
          'Security',
          'Multi-Signature',
          'Auto Rectification',
          'Multiple Currency Support',
        ],
      },
    ],
  },
};

const IndustriesPage = {
  heading: 'Modern Problems require Modern Solutions, We provide them, Easy',
  overview:
    `We, as a team of experts, understand challenges faced by early-stage businesses to well-settled brands facing modern market challenges.\n Our business analysts and developers work hand in hand, which makes us fully competent of providing all-round solutions to our customers, whether it's that small technical glitch or that massive financial conundrum, we are the go-to team for you.`,
  industries: [
    healthCare,
    socialMedia,
    travel,
    onDemand,
    education,
    mediaAndEntertainment,
    event,
    realEstate,
    automobile,
    saas,
    enterprise,
    virtualReality,
  ],
  navigation: {
    prev: {
      title: 'Services',
      overview:
        'There is phenomenal digital transformation and emergence of automation in all spheres of business. We have worked across a vast range of industries and cater to the finest of technical expertise required for your business needs.',
    },
    next: {
      title: 'Technology',
      overview:
        'From basics to path-breaking technologies, we hack all of them with sheer precision and excellence. We work on varied platforms and disruptive technologies',
    },
  },
  subPage: {
    event,
    enterprise,
    automobile,
    mediaAndEntertainment,
    education,
    realEstate,
    onDemand,
    virtualReality,
    travel,
    saas,
    socialMedia,
    healthCare,
    finTech,
  },
};

export default IndustriesPage;
